var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.125C6.91922 1.1501 4.93073 1.98785 3.45929 3.45929C1.98785 4.93073 1.1501 6.91922 1.125 9C1.1501 11.0808 1.98785 13.0693 3.45929 14.5407C4.93073 16.0122 6.91922 16.8499 9 16.875C11.0808 16.8499 13.0693 16.0122 14.5407 14.5407C16.0122 13.0693 16.8499 11.0808 16.875 9C16.8499 6.91922 16.0122 4.93073 14.5407 3.45929C13.0693 1.98785 11.0808 1.1501 9 1.125Z",
    fill: "#395FEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 9.5625H13.5V8.4375H9.5625V4.5H8.4375V8.4375H4.5V9.5625H8.4375V13.5H9.5625V9.5625Z",
    fill: "#F9FAFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddItem);
export default __webpack_public_path__ + "static/media/addItem.bb4eb85bd0bab25ea29a8fd2e05adbc6.svg";
export { ForwardRef as ReactComponent };